import(/* webpackMode: "eager", webpackExports: ["PriceChart"] */ "/app/src/components/prices/PriceChart.tsx");
